// @flow

// list campaign
export const GET_LIST_PRE_ORDER_CAMPAIGNS_REQUEST = 'GET_LIST_PRE_ORDER_CAMPAIGNS_REQUEST';

export const GET_LIST_PRE_ORDER_CAMPAIGNS_SUCCESS = 'GET_LIST_PRE_ORDER_CAMPAIGNS_SUCCESS';

export const GET_LIST_PRE_ORDER_CAMPAIGNS_FAILURE = 'GET_LIST_PRE_ORDER_CAMPAIGNS_FAILURE';

// get campaign
export const GET_PRE_ORDER_CAMPAIGN_REQUEST = 'GET_PRE_ORDER_CAMPAIGN_REQUEST';

export const GET_PRE_ORDER_CAMPAIGN_SUCCESS = 'GET_PRE_ORDER_CAMPAIGN_SUCCESS';

export const GET_PRE_ORDER_CAMPAIGN_FAILURE = 'GET_PRE_ORDER_CAMPAIGN_FAILURE';

// create campaign
export const CREATE_PRE_ORDER_CAMPAIGN_REQUEST = 'CREATE_PRE_ORDER_CAMPAIGN_REQUEST';

export const CREATE_PRE_ORDER_CAMPAIGN_SUCCESS = 'CREATE_PRE_ORDER_CAMPAIGN_SUCCESS';

export const CREATE_PRE_ORDER_CAMPAIGN_FAILURE = 'CREATE_PRE_ORDER_CAMPAIGN_FAILURE';

// update campaign
export const UPDATE_PRE_ORDER_CAMPAIGN_REQUEST = 'UPDATE_PRE_ORDER_CAMPAIGN_REQUEST';

export const UPDATE_PRE_ORDER_CAMPAIGN_SUCCESS = 'UPDATE_PRE_ORDER_CAMPAIGN_SUCCESS';

export const UPDATE_PRE_ORDER_CAMPAIGN_FAILURE = 'UPDATE_PRE_ORDER_CAMPAIGN_FAILURE';

// duplicate campaign
export const DUPLICATE_PRE_ORDER_CAMPAIGN_REQUEST = 'DUPLICATE_PRE_ORDER_CAMPAIGN_REQUEST';

export const DUPLICATE_PRE_ORDER_CAMPAIGN_SUCCESS = 'DUPLICATE_PRE_ORDER_CAMPAIGN_SUCCESS';

export const DUPLICATE_PRE_ORDER_CAMPAIGN_FAILURE = 'DUPLICATE_PRE_ORDER_CAMPAIGN_FAILURE';

// delete campaign
export const DELETE_PRE_ORDER_CAMPAIGN_REQUEST = 'DELETE_PRE_ORDER_CAMPAIGN_REQUEST';

export const DELETE_PRE_ORDER_CAMPAIGN_SUCCESS = 'DELETE_PRE_ORDER_CAMPAIGN_SUCCESS';

export const DELETE_PRE_ORDER_CAMPAIGN_FAILURE = 'DELETE_PRE_ORDER_CAMPAIGN_FAILURE';

// ---- GENERAL SETTINGS ----
// get general settings
export const GET_PRE_ORDER_GENERAL_SETTINGS_REQUEST = 'GET_PRE_ORDER_GENERAL_SETTINGS_REQUEST';

export const GET_PRE_ORDER_GENERAL_SETTINGS_SUCCESS = 'GET_PRE_ORDER_GENERAL_SETTINGS_SUCCESS';

export const GET_PRE_ORDER_GENERAL_SETTINGS_FAILURE = 'GET_PRE_ORDER_GENERAL_SETTINGS_FAILURE';

export const UPDATE_PRE_ORDER_GENERAL_SETTINGS_REQUEST =
  'UPDATE_PRE_ORDER_GENERAL_SETTINGS_REQUEST';

export const UPDATE_PRE_ORDER_GENERAL_SETTINGS_SUCCESS =
  'UPDATE_PRE_ORDER_GENERAL_SETTINGS_SUCCESS';

export const UPDATE_PRE_ORDER_GENERAL_SETTINGS_FAILURE =
  'UPDATE_PRE_ORDER_GENERAL_SETTINGS_FAILURE';
